import { createGlobalStyle } from 'styled-components';
import 'normalize.css';

const CssBaseline = createGlobalStyle`
  html, body, #root {
    height: 100vh;
  }
  #root {
    overflow: auto;
  }
  * {
    box-sizing: border-box;
  }

  ul {
    list-style: none;
    margin: 0;
    padding: 0;
  }
`;

export default CssBaseline;
